import { Box } from '@chakra-ui/react';

import BadgeEcomerce from 'Component/badge-ecommerce';
import { tablePromoText } from 'Const/stock-promo/view';
import { TextMedium, TextRegular } from 'UiKit/typography';

import BadgeStatusPromo from 'View/stock-promo/component/badgeStatusPromo';

import styles from './styles.module.css';

const ColumnPromoStatusToko = ({ value, values }) => {
  return (
    <Box className={styles['column-promo__container']}>
      <TextRegular className={styles['column-promo__text--promo-name']}>{value}</TextRegular>
      <Box className={styles['column-promo__box--promo-period']}>
        <TextMedium className={styles['column-promo__text--promo-period']}>{tablePromoText.periodePromoText}</TextMedium>
        <TextMedium className={styles['column-promo__text--promo-period']}>{values.promoPeriod}</TextMedium>
      </Box>
      <Box>
        <Box className={styles['column-promo__badge--promo-status']}>
          <BadgeStatusPromo status={values.status} />
          <BadgeEcomerce ecommerce={values?.ecommerce} accountName={values?.storeName} />
        </Box>
      </Box>
    </Box>
  );
};

export default ColumnPromoStatusToko;
